import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import FormHelperText from '@material-ui/core/FormHelperText';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  bootstrapRoot: {
    'border': 'none',
    'borderBottom': '1px solid #ced4da',
    'flex': 1,
    'label + &': {
      marginTop: theme.spacing(1),
    },
  },
  multiline: {
    padding: 0,
  },
  bootstrapInput: {
    outline: 'none',
    position: 'relative',
    fontSize: 16,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
  descriptionText: {
    fontSize: 11,
    fontWeight: 300,
    color: theme.palette.grey[700],
  },
  bootstrapFormLabel: {
    'fontSize': 12,
    'fontWeight': 300,
    'color': theme.palette.grey[700],
    '&.flexBox': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '&.labelInline': {
      width: 120,
      textAlign: 'right',
      marginRight: 16,
      marginBottom: 0,
    },
  },
  dropdownButton: {
    textTransform: 'none',
    fontWeight: '500',
    fontSize: 16,
    padding: 0,
  },
  control: {
    // marginBottom: 0,
    // marginTop: 24,
  },
  controlInline: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
});

class CustomInput extends PureComponent {
  renderInput = (props) => {
    const { inputRef, onChange, ...other } = props;
    const { id, name, classes } = this.props;
    return (
      <InputBase
        id={id}
        classes={{
          root: classes.bootstrapRoot,
          input: classes.bootstrapInput,
          multiline: classes.multiline,
        }}
        {...props}
      />
    );
  };
  render() {
    const {
      classes,
      hasError,
      helpText,
      id,
      label,
      description,
      onDropdownClick,
      dropdownId,
      anchorEl,
      labelStyle,
      controlStyle,
      containerStyle,
      inline,
      variant,
      margin = 'normal',
      ...otherProps
    } = this.props;
    return (
      <div className={classes.root} style={containerStyle}>
        <FormControl
          className={cx(classes.control, inline && classes.controlInline)}
          style={controlStyle}
          fullWidth
          margin={margin}
          variant={variant}
          error={hasError}
        >
          {!!label && (
            <FormLabel
              component="label"
              htmlFor={id}
              className={cx(
                classes.bootstrapFormLabel,
                { labelInline: inline },
                { flexBox: onDropdownClick },
              )}
              style={labelStyle}
            >
              {label}
              {otherProps.required && (
                <span style={{ paddingLeft: 3, color: 'red' }}>*</span>
              )}
              {onDropdownClick && (
                <Button
                  className={classes.dropdownButton}
                  aria-owns={anchorEl ? dropdownId : undefined}
                  aria-haspopup="true"
                  onClick={onDropdownClick}
                >
                  Shortcodes
                  <ArrowDropDown />
                </Button>
              )}
            </FormLabel>
          )}
          {description && (
            <FormLabel component="label" className={classes.descriptionText}>
              {description}
            </FormLabel>
          )}
          {this.renderInput(otherProps)}
          {helpText && <FormHelperText>{helpText}</FormHelperText>}
        </FormControl>
      </div>
    );
  }
}

CustomInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string,
  dropdownId: PropTypes.string,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
};

CustomInput.defaultProps = {
  id: 'input',
  dropdownId: 'menu',
};

export default withStyles(styles)(CustomInput);
